module.exports = __webpack_public_path__ + "img/componente-nfse.3e7100b4.png";